export const validationMessages = {
  required: 'Поле обязательно для заполнения',
  onlyCyrillic: 'Содержатся некорректные символы',
  email: 'Некорректный email',
  phone: 'Неверный формат номера телефона',
  minLength: 'Длина не должна быть меньше ${min}',  
  maxLength: 'Длина не должна быть больше ${max}',  
  minLengthCount: `$\{length}/15 000 символов. Минимальное количество символов — $\{min}`,
  betweenNumber: 'Значение должно быть не меньше ${min} и не больше ${max}',  
  websiteUrl: 'Неверный формат ссылки вебсайта'
}
